import { useSelector } from "react-redux";
import { useLocation, Outlet, Navigate } from "react-router-dom";
import { selectCurrentUser, selectCurrentUserToken } from "../../store/user/userSelector";
export default function NotRequireAuth() {
  const state = useSelector((state) => state);
  let auth = { user: selectCurrentUser(state), token: selectCurrentUserToken(state) };
  
  let location = useLocation();
  if (auth.token) {
    // Redirect them to the /home page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={location.state ? location.state.from:'/explore/opened-projects?topic_category_id=1'}  state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
